import { ModalElement } from './modal'
import { ReadMore } from './read-more'

export class AccordionGroup extends HTMLElement {
  accordions: NodeListOf<ModalElement> | null = null
  readMoreElements: NodeListOf<ReadMore> | null = null
  observer: MutationObserver | null = null

  connectedCallback() {
    this.findChildren()
    this.setupObserver()
    this.handleInitialState()
  }

  disconnectedCallback() {
    this.observer?.disconnect()
  }

  findChildren() {
    this.accordions = this.querySelectorAll('x-modal')
    this.readMoreElements = this.querySelectorAll('read-more')
  }

  handleInitialState() {
    const expandedReadMore = Array.from(this.readMoreElements || []).find(
      (el) => el.classList.contains('is-active')
    )

    const expandedAccordion = Array.from(this.accordions || []).find(
      (el) => el.dataset.ui === 'visible'
    )

    if (expandedReadMore) {
      this.closeAllExcept(expandedReadMore)
    } else if (expandedAccordion) {
      this.closeAllExcept(expandedAccordion)
    }
  }

  setupObserver() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const target = mutation.target as HTMLElement

          if (target.tagName === 'X-MODAL' && target.dataset.ui === 'visible') {
            this.closeAllExcept(target)
          }

          if (target.tagName === 'READ-MORE' && target.classList.contains('is-active')) {
            this.closeAllExcept(target)
          }
        }
      })
    })

    this.accordions?.forEach((accordion) => {
      this.observer?.observe(accordion, {
        attributes: true,
        attributeFilter: ['data-ui']
      })
    })

    this.readMoreElements?.forEach((readMore) => {
      this.observer?.observe(readMore, {
        attributes: true,
        attributeFilter: ['class']
      })
    })
  }

  closeAllExcept(openedElement: HTMLElement) {
    this.accordions?.forEach((accordion) => {
      if (accordion !== openedElement && accordion.dataset.ui === 'visible') {
        (accordion as ModalElement).handleHide()
      }
    })

    this.readMoreElements?.forEach((readMore) => {
      if (readMore !== openedElement && readMore.classList.contains('is-active')) {
        if (readMore.isExpand) {
          readMore.collapse()
        }
      }
    })
  }
}
